export const BetPriceChangeEnum = {
    AlwaysAsk: 0,
    AcceptHigherOdds: 1,
    AcceptAnyOdds: 2,
    CounterOffer: 3,
};